import {
  controllerSourceNames,
  mobileSourceNames,
  sharedSourceNames,
  webSourceNames,
} from './sourceNames';
import {
  BaseGamePadBaseDrawer,
  BaseGamePadMobileDrawer,
  BaseGamePadWebDrawer,
} from 'bog-arcade-core-ui/drawers';

const baseGamePadBaseDrawer = new BaseGamePadBaseDrawer();
const baseGamePadMobileDrawer = new BaseGamePadMobileDrawer();
const baseGamePadWebDrawer = new BaseGamePadWebDrawer();

export const sharedSources = [
  { name: sharedSourceNames.balls, path: 'assets/shared/balls.png' },
  { name: sharedSourceNames.freeSpin, path: 'assets/shared/free_spins.png' },
  { name: sharedSourceNames.multiplier, path: 'assets/shared/multiplier.png' },
  { name: sharedSourceNames.winBackground, path: 'assets/shared/win_background.png' },
  { name: sharedSourceNames.ticketX1Light, path: 'assets/shared/tickets/light_x_1.png' },
  { name: sharedSourceNames.ticketX3Light, path: 'assets/shared/tickets/light_x_3.png' },
  { name: sharedSourceNames.ticketX5Light, path: 'assets/shared/tickets/light_x_5.png' },
  { name: sharedSourceNames.ticketX1, path: 'assets/shared/tickets/x_1.png' },
  { name: sharedSourceNames.ticketX3, path: 'assets/shared/tickets/x_3.png' },
  { name: sharedSourceNames.ticketX5, path: 'assets/shared/tickets/x_5.png' },
  { name: sharedSourceNames.continueButtonActive, path: 'assets/shared/popups/continue_button_active.png' },
  { name: sharedSourceNames.continueButtonNormal, path: 'assets/shared/popups/continue_button_normal.png' },
  { name: sharedSourceNames.congratulationsPopup, path: 'assets/shared/popups/congratulations_popup.png' },
  { name: sharedSourceNames.ticketX1Bow, path: 'assets/shared/tickets/x_1_bow.png' },
  { name: sharedSourceNames.ticketX3Bow, path: 'assets/shared/tickets/x_3_bow.png' },
  { name: sharedSourceNames.ticketX5Bow, path: 'assets/shared/tickets/x_5_bow.png' },
  { name: sharedSourceNames.buttonNoActive, path: 'assets/shared/popups/button_no_active.png' },
  { name: sharedSourceNames.buttonNoNormal, path: 'assets/shared/popups/button_no_normal.png' },
  { name: sharedSourceNames.buttonYesActive, path: 'assets/shared/popups/button_yes_active.png' },
  { name: sharedSourceNames.buttonYesNormal, path: 'assets/shared/popups/button_yes_normal.png' },
  { name: sharedSourceNames.buyBonusPopup, path: 'assets/shared/popups/buy_bonus_popup.png' },
  { name: sharedSourceNames.goldenArrow, path: 'assets/shared/popups/golden_arrow.png' },
  { name: sharedSourceNames.backgroundShadow, path: 'assets/shared/popups/background_shadow.svg' },
  { name: mobileSourceNames.shadowBottom, path: 'assets/mobile/shadow_bottom.svg' },
  { name: sharedSourceNames.bonusLeaf, path: 'assets/shared//popups/bonus_leaf.png' },
  {
    name: sharedSourceNames.greenPopupLightSpine,
    path: 'animations/shared/green_popup/green_popup.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/shared/green_popup/green_popup.atlas',
      },
    },
  },
  {
    name: sharedSourceNames.purplePopupLightSpine,
    path: 'animations/shared/purple_popup/purple_popup.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/shared/purple_popup/purple_popup.atlas',
      },
    },
  },
  {
    name: sharedSourceNames.leaf,
    path: 'animations/shared/leaf/terev.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/shared/leaf/terev.atlas',
      },
    },
  },
];

export const gamePadSharedResource = [
  { name: baseGamePadBaseDrawer.sourceNames.spinIcon, path: 'assets/gamePadSrc/spin_icon.svg' },
  { name: baseGamePadBaseDrawer.sourceNames.plusIcon, path: 'assets/gamePadSrc/plus_icon.svg' },
  { name: baseGamePadBaseDrawer.sourceNames.minusIcon, path: 'assets/gamePadSrc/minus_icon.svg' },
  { name: baseGamePadBaseDrawer.sourceNames.infinityIcon, path: 'assets/gamePadSrc/infinity_icon.svg' },
  { name: baseGamePadBaseDrawer.sourceNames.infinityDarkIcon, path: 'assets/gamePadSrc/infinity_icon_bark.svg' },
  { name: baseGamePadBaseDrawer.sourceNames.leftArrowIcon, path: 'assets/gamePadSrc/left_arrow_icon.svg' },
  { name: baseGamePadBaseDrawer.sourceNames.rightArrowIcon, path: 'assets/gamePadSrc/right_arrow_icon.svg' },
  { name: sharedSourceNames.autoSpinStopIcon, path: 'assets/gamePadSrc/auto_spin_icon.svg' },
  { name: sharedSourceNames.switchIcon, path: 'assets/shared/icons/switch_icon.svg' },
  { name: sharedSourceNames.infinityIconBark, path: 'assets/gamePadSrc/infinity_icon_bark.svg' },
  { name: sharedSourceNames.depositIcon, path: 'assets/gamePadSrc/deposit_icon.svg' },
];

export const controlPadSharedResources = [
  { name: controllerSourceNames.controlWhiteCircle, path: 'assets/shared/icons/control_white_circle.svg' },
  { name: controllerSourceNames.soundOnIcon, path: 'assets/shared/icons/sound_on_icon.svg' },
  { name: controllerSourceNames.soundOffIcon, path: 'assets/shared/icons/sound_off_icon.svg' },
  { name: controllerSourceNames.soundOffIconMobile, path: 'assets/shared/icons/sound_off_icon_mobile.svg' },
  { name: controllerSourceNames.historyIcon, path: 'assets/shared/icons/history_icon.svg' },
  { name: controllerSourceNames.historyIconMobile, path: 'assets/shared/icons/history_icon_mobile.svg' },
  { name: controllerSourceNames.historyIconActive, path: 'assets/shared/icons/history_icon_active.svg' },
  { name: controllerSourceNames.infoIcon, path: 'assets/shared/icons/info_icon.svg' },
  { name: controllerSourceNames.infoIconMobile, path: 'assets/shared/icons/info_icon_mobile.svg' },
  { name: controllerSourceNames.infoIconActive, path: 'assets/shared/icons/info_icon_active.svg' },
];

export const gamePadMobileResource = [
  ...gamePadSharedResource,
  { name: baseGamePadMobileDrawer.sourceNames.borderCircle, path: 'assets/gamePadSrc/border_circle.svg' },
  { name: baseGamePadMobileDrawer.sourceNames.borderCircleActive, path: 'assets/gamePadSrc/border_circle_active.svg' },
  { name: baseGamePadMobileDrawer.sourceNames.autoSpinPlayIcon, path: 'assets/gamePadSrc/auto_play_icon.svg' },
  { name: baseGamePadMobileDrawer.sourceNames.buttonsContent, path: 'assets/gamePadSrc/buttons_content.svg' },
  { name: baseGamePadMobileDrawer.sourceNames.coinsIcon, path: 'assets/gamePadSrc/coins_icon.svg' },
];

export const gamePadWebResource = [
  ...gamePadSharedResource,
  { name: baseGamePadWebDrawer.sourceNames.roundedContainer, path: 'assets/gamePadSrc/roundedContainer.svg' },
  {
    name: baseGamePadWebDrawer.sourceNames.roundedContainerActive,
    path: 'assets/gamePadSrc/roundedContainerActive.svg',
  },
];

export const mobileSources = [
  ...sharedSources,
  { name: mobileSourceNames.background, path: 'assets/mobile/background.jpg' },
  { name: mobileSourceNames.shadow, path: 'assets/mobile/shadow.png' },
  { name: mobileSourceNames.tiki, path: 'assets/mobile/tiki.png' },
  { name: mobileSourceNames.tikiBack, path: 'assets/mobile/tiki_back.png' },
  {
    name: mobileSourceNames.dragonSoulSpine,
    path: 'animations/mobile/dragon_soul/frames.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/dragon_soul/frames.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.plateSpine,
    path: 'animations/mobile/plate/plate.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/plate/plate.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.breakingBallSpine,
    path: 'animations/mobile/breaking_ball/ball_break_light.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/breaking_ball/ball_break_light.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.particles,
    path: 'animations/mobile/particles/particles.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/particles/particles.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.dragonSpine,
    path: 'animations/mobile/dragon/dragon.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/dragon/dragon.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.treesSpine,
    path: 'animations/mobile/trees/trees.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/trees/trees.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.wallSpine,
    path: 'animations/mobile/wall/wall.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/wall/wall.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.waterSpine,
    path: 'animations/mobile/water/water.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/water/water.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.waterfallSpine,
    path: 'animations/mobile/waterfall/waterfall.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/waterfall/waterfall.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.fishSpine,
    path: 'animations/mobile/fish/water.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/fish/water.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.bigWinCoinsSpine,
    path: 'animations/mobile/big_win/big_win_coins/coins.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/big_win/big_win_coins/coins.atlas',
      },
    },
  },
  {
    name: mobileSourceNames.bigWinWordsSpine,
    path: 'animations/mobile/big_win/big_win_words/big_win.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/mobile/big_win/big_win_words/big_win.atlas',
      },
    },
  },
];

export const webSources = [
  ...sharedSources,
  ...gamePadWebResource,
  { name: webSourceNames.background, path: 'assets/web/background.jpg' },
  { name: webSourceNames.shadow, path: 'assets/web/shadow.png' },
  { name: webSourceNames.tiki, path: 'assets/web/tiki.png' },
  { name: webSourceNames.tikiBack, path: 'assets/web/tiki_back.png' },
  { name: webSourceNames.buyBonusButton, path: 'assets/web/buy_bonus_button.png' },
  {
    name: webSourceNames.breakingBallSpine,
    path: 'animations/web/breaking_ball/ball_break_light.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/breaking_ball/ball_break_light.atlas',
      },
    },
  },
  {
    name: webSourceNames.particles,
    path: 'animations/web/particles/particles.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/particles/particles.atlas',
      },
    },
  },
  {
    name: webSourceNames.dragonSpine,
    path: 'animations/web/dragon/dragon.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/dragon/dragon.atlas',
      },
    },
  },
  {
    name: webSourceNames.dragonSoulSpine,
    path: 'animations/web/dragon_soul/frames.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/dragon_soul/frames.atlas',
      },
    },
  },
  {
    name: webSourceNames.treesSpine,
    path: 'animations/web/trees/trees.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/trees/trees.atlas',
      },
    },
  },
  {
    name: webSourceNames.wallSpine,
    path: 'animations/web/wall/wall.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/wall/wall.atlas',
      },
    },
  },
  {
    name: webSourceNames.waterSpine,
    path: 'animations/web/water/water.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/water/water.atlas',
      },
    },
  },
  {
    name: webSourceNames.waterfallSpine,
    path: 'animations/web/waterfall/waterfall.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/waterfall/waterfall.atlas',
      },
    },
  },
  {
    name: webSourceNames.fishSpine,
    path: 'animations/web/fish/water.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/fish/water.atlas',
      },
    },
  },
  {
    name: webSourceNames.bigWinCoinsSpine,
    path: 'animations/web/big_win/big_win_coins/coins.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/big_win/big_win_coins/coins.atlas',
      },
    },
  },
  {
    name: webSourceNames.bigWinWordsSpine,
    path: 'animations/web/big_win/big_win_words/big_win.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/web/big_win/big_win_words/big_win.atlas',
      },
    },
  },
];
